require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[54],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(471);


/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _Separator = _interopRequireDefault(__webpack_require__(472));

exports["default"] = _Separator["default"];
exports.Separator = _Separator["default"];

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _Separator = _interopRequireDefault(__webpack_require__(473));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var separatorClassName = _Separator["default"].separatorClassName.replace(/"/g, '');

var cssSize = _utils.cssUtils.cssSize;
var sanitize = _utils.propsUtils.sanitize;

var Separator = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(Separator, _Component);

  function Separator() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Separator.prototype;

  _proto.render = function render() {
    var _cx;

    var _this$props = this.props,
        fullWidth = _this$props.fullWidth,
        orientation = _this$props.orientation,
        hMargin = _this$props.hMargin,
        className = _this$props.className,
        style = _this$props.style,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props, ["fullWidth", "orientation", "hMargin", "className", "style"]);
    var classNames = (0, _utils.classnames)("" + separatorClassName, (_cx = {
      fullWidth: fullWidth
    }, _cx[orientation] = orientation, _cx));

    if (fullWidth) {
      console.warn("Warning: 'fullWidth' is going to be deprecated in Sprint 39.1, please use 'hMargin={0}' instead (see RTC 220292)."); // eslint-disable-line no-console
    }

    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, Separator), {
      role: "separator",
      className: classNames + " " + className,
      style: (0, _extends2["default"])({
        margin: "0 " + cssSize(hMargin) + "px"
      }, style)
    }));
  };

  return Separator;
}(_react.Component);

exports["default"] = Separator;
(0, _defineProperty2["default"])(Separator, "propTypes", {
  /** If set to true, it takes all available width */
  fullWidth: _propTypes["default"].bool,

  /** Choose the orientation of separator */
  orientation: _propTypes["default"].oneOf(['horizontal', 'vertical']),

  /** Control the left and right margins (actual margin = 8px * hMargin) */
  hMargin: _propTypes["default"].number,

  /** Class name to be passed to separator */
  className: _propTypes["default"].string,

  /** Style object to be passed as the inline styling */
  style: _propTypes["default"].object
});
(0, _defineProperty2["default"])(Separator, "defaultProps", {
  orientation: 'horizontal',
  hMargin: 1,
  className: '',
  style: {}
});

/***/ }),

/***/ 473:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(474);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 474:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-separator{border-color:#e0e0e0}.ba-common-separator.is-fullWidth{margin:0 !important}.ba-common-separator.is-horizontal{line-height:0;border-top-width:1px;border-top-style:solid}.ba-common-separator.is-vertical{display:inline-block;height:100%;border-left-width:1px;border-left-style:solid;vertical-align:middle}.ba-common-separator{transition:border-color .2s ease-in-out}\n", ""]);

// exports
exports.locals = {
	"separatorClassName": "\"ba-common-separator\""
};

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[470,0]]]);
});